import { render, staticRenderFns } from "./rewardsDetail.vue?vue&type=template&id=9c225878"
import script from "./rewardsDetail.vue?vue&type=script&lang=js"
export * from "./rewardsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports